import React, { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { HiHome } from "react-icons/hi";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { BiPlus, BiMinus } from "react-icons/bi";
import { Popover, Transition, Dialog as DailogUi } from "@headlessui/react";
import WrapFour from '../../../assets/wrapFour.png';
import WrapFive from '../../../assets/wrapFive.png';
import { useNavigate } from "react-router-dom";
import RxjsStoreContext from "../../../context/RxjsStoreContext";
import CurrencyFormat from "react-currency-format";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { authService } from "../../../services/authService";
import LogicContext from "../../../context/LogicContext";
import { CgClose } from "react-icons/cg";
import AccountImage from "../../../assets/LogIntoYourAccount.svg";
import MinimumBasketImage from "../../../assets/minimumBasketImage.svg";
import { FaMinus, FaPlus } from "react-icons/fa";
import Modal from "../../Ui";
import { useDispatch, useSelector } from "react-redux";
import { setCustomBasketRemark } from "../../../store/slices/cartSlice";
import CherriesImage from "../../../assets/cherriesImage.png"
import { IoClose } from "react-icons/io5";

function MyBasketList() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { customBasketRemark } = useSelector((state) => state.cart);
  const logicContext = useContext(LogicContext);
  const [count, setCount] = useState(3);
  const [recurrMonths, setRecurrMonths] = useState(3);
  const [discountValue, setDisCountValue] = useState(0);
  const [priceAlert, showPriceAlert] = useState(false);
  const [isRecurring, setIsRecurring] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedModal, setSelectedModal] = useState("");
  const [monthlyRecurring, setMonthlyRecurring] = useState("no");
  const [remark, setRemark] = useState(customBasketRemark ? customBasketRemark : "");
  const [isMissingProd, setIsMissingProd] = useState("");
  const [grochilsSectionModal, setGrochilsSectionModal] = useState(false);
  const [allGrochillProductList, setAllGrochillProductList] = useState([]);
  const [allPickProductList, setAllPickProductList] = useState([]);

  const [customBasket, setCustomBasket] = useState({});

  const rxjsStore = useContext(RxjsStoreContext);
  const [open, setOpen] = React.useState(false);
  const [basketProductMap, setBasketProductMap] = useState(new Map());

  useEffect(() => {
    rxjsStore.getUserSelectedBasket().subscribe((data) => {
      let productSelected = new Map(data);
      setBasketProductMap(productSelected);
    });

    return () => {
      updateBasketList();
      //   rxjsStore.saveBasketTemporarily();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    rxjsStore.getAllButcherProductList().subscribe((allProduct) => {
      setAllGrochillProductList(allProduct);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    rxjsStore.getAllBasketProductList().subscribe((allProduct) => {
      setAllPickProductList(allProduct);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //  For custom gift basket
  useEffect(() => {
    let tempCustomBasket = {
      plan_name: "Custom Basket",
      notes: "",
      discount: "00.00%",
      customer_id: authService.getCurrentUserZohoCustomerId(),
      shipping_charge: 0,
      adjustment: 0,
      adjustment_description: "custom basket item",
      exchange_rate: 1,
      line_items: [],
    };

    rxjsStore.getUserSelectedBasket().subscribe((productsListMap) => {
      for (let [key, product] of productsListMap) {
        const tempItems = {
          item_id: product.item_id,
          name: product.name,
          rate: product.item_rate_zoho,
          quantity: product.qty,
          unit: product.unit,
          type: product?.type,
          sku: product.sku,
          item_total: product.qty * Number(product.item_rate_zoho),
        };
        tempCustomBasket.line_items.push(tempItems);
      }
      setCustomBasket(tempCustomBasket);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isRecurring) {
      localStorage.setItem("custom_isInfinite", "yes");
    } else if (!isRecurring) {
      localStorage.setItem("custom_isInfinite", "no");
    }
  }, [isRecurring]);

  useEffect(() => {
    if (recurrMonths) {
      localStorage.setItem("custom_recurr_months", recurrMonths);
    }
  }, [recurrMonths])

  const handleProductCheck = useCallback((items) => {
    try {
      if (items?.length) {
        let isBasket = false;
        let isButcher = false;

        items?.forEach((item) => {
          if (item?.type === "BASKET") {
            isBasket = true;
          }
          if (item?.type === "BUTCHER") {
            isButcher = true;
          }
        });

        return {
          isBasket,
          isButcher
        }
      }
    } catch (err) {
      return err;
    }
  }, []);

  useEffect(() => {
    if (customBasket) {
      const availableProducts = handleProductCheck(customBasket.line_items);

      if (!availableProducts?.isBasket || !availableProducts?.isButcher) {
        setGrochilsSectionModal(true);
        if (!availableProducts?.isBasket) setIsMissingProd("isBasket");
        if (!availableProducts?.isButcher) setIsMissingProd("isButcher");
      } else if (availableProducts?.isBasket || availableProducts?.isButcher) {
        setGrochilsSectionModal(false);
        if (!availableProducts?.isBasket) setIsMissingProd("");
        if (!availableProducts?.isButcher) setIsMissingProd("");
      }
    }
  }, [customBasket, handleProductCheck]);

  const updateBasketList = () => {
    for (let [key, product] of basketProductMap) {
      rxjsStore.setUserSelectedBasket(product, product.qty);
    }
  };

  const handleChange = () => {
    setIsRecurring((prev) => !prev);
  };

  const switchToMonthly = () => {
    // const isChnging = "allow";
    setSelectedOption("yes");
    setMonthlyRecurring("yes");
  };

  function removeQuantity(key) {
    basketProductMap.delete(key);
    rxjsStore.removeItemFromBasket(key);
    setCount((prev) => (prev += 1));
  }

  function incrementQuantity(key, qty) {
    rxjsStore.incrementQuantity(key, qty);
    // setCount(prev => prev += 1);
  }

  function decrementProduct(key, qty) {
    rxjsStore.decrementQuantity(key, qty);
  }

  function calculateSaving(basketListMap) {
    let total = 0;
    for (let [key, product] of basketListMap) {
      total += product?.item_rate_market * product.qty;
    }
    return total - grandTotal();
  }

  const handleOnClose = () => {
    setShowModal(false);
    setSelectedModal("");
  };

  const handleMonthlyRecurring = (event) => {
    if (event.target.value === "no") {
      setShowModal(true);
      setSelectedModal("recurr");
      setSelectedOption(event.target.value);
      setMonthlyRecurring(event.target.value);
      localStorage.setItem("custom_isrecurring", "no");
      return;
    }
    if (event.target.value === "yes") {
      setMonthlyRecurring(event.target.value);
      setSelectedOption(event.target.value);
      localStorage.setItem("custom_isrecurring", "yes");
    }
  };

  function displayProduct() {
    const comps = [];
    basketProductMap.forEach((product, index) =>
      comps.push(
        <div
          key={index}
          className="flex justify-between font-semibold sm:grid sm:grid-cols-4 sm:items-center"
        >
          <div className="mt-4 grid justify-start sm:col-span-2">
            <div className="flex items-center space-x-2">
              <div className="rounded-md border-[1px] border-gray-300">
                <img
                  src={product?.item_image_url}
                  className="aspect-auto h-10 w-9 rounded-md object-cover sm:h-14 sm:w-12"
                  alt=""
                />
              </div>
              <div className="-space-y-[6px] text-[9px] font-semibold text-gray-500 sm:-space-y-1 sm:text-[10px]">
                <div>{product?.name} </div>
                <div className="flex items-center text-[10px] font-normal text-red-600">
                    <svg width="12" height="12" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.00016 2.16683C9.94083 2.16683 12.3335 4.5595 12.3335 7.50016C12.3335 10.4408 9.94083 12.8335 7.00016 12.8335C4.0595 12.8335 1.66683 10.4408 1.66683 7.50016C1.66683 4.5595 4.0595 2.16683 7.00016 2.16683ZM7.00016 0.833496C3.31816 0.833496 0.333496 3.81816 0.333496 7.50016C0.333496 11.1822 3.31816 14.1668 7.00016 14.1668C10.6822 14.1668 13.6668 11.1822 13.6668 7.50016C13.6668 3.81816 10.6822 0.833496 7.00016 0.833496ZM7.66683 9.50016H6.3335V10.8335H7.66683V9.50016ZM6.3335 8.16683H7.66683L8.00016 4.16683H6.00016L6.3335 8.16683Z" fill="#E51E26"/>
                    </svg>
                    <span className="ml-1">8 items Left</span>
                </div>
                <div>
                  <div className="flex items-center space-x-1">
                    <p>Grocedy Price:</p>
                    <CurrencyFormat
                      className={"font-bold "}
                      value={Number.parseFloat(
                        product?.item_rate_zoho
                      )?.toFixed(2)}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"₦"}
                    />
                  </div>
                </div>
                <div className="flex items-center space-x-1 text-red-400">
                  <p>Market Price:</p>
                  <p className="line-through">
                    <CurrencyFormat
                      className={"font-bold "}
                      value={Number.parseFloat(
                        product?.item_rate_market
                      )?.toFixed(2)}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"₦"}
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-5 xsm:mt-4 xsm:flex xsm:items-center xsm:space-x-2 sm:col-span-1 sm:grid sm:justify-center">
            <div className="grid h-6 w-20 grid-cols-3 rounded border-[0.5px] border-gray-400 sm:w-24">
              <div className="col-span-1 grid items-center justify-center">
                <BiMinus
                  onClick={() => decrementProduct(product?.sku, 1)}
                  className="h-4 w-4 cursor-pointer rounded-full text-gray-600 hover:bg-gray-100 active:bg-gray-200"
                />
              </div>

              <div className="col-span-1 grid items-center justify-center text-gray-600">
                {product?.qty}
              </div>
              <div className="col-span-1 grid items-center justify-center">
                <BiPlus
                  onClick={() => incrementQuantity(product?.sku, 1)}
                  className="h-4 w-4 cursor-pointer rounded-full text-gray-600 hover:bg-gray-100 active:bg-gray-200"
                />
              </div>
            </div>
            <div
              className="mt-[1px] grid cursor-pointer justify-center text-[10px]
                     text-red-400 hover:underline hover:underline-offset-1 xsm:mt-0 sm:mt-[1px]"
              onClick={() => removeQuantity(product?.sku)}
            >
              REMOVE
            </div>
          </div>
          <div className="mt-2 hidden sm:col-span-1 sm:grid sm:justify-end">
            <div className="text-xs font-medium text-gray-600">
              <CurrencyFormat
                className={"font-medium  "}
                value={Number.parseFloat(
                  Number(product?.item_rate_zoho) * product?.qty
                )?.toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"₦"}
              />
            </div>
          </div>
        </div>
      )
    );
    return comps;
  }

  function grandTotal() {
    let total = 0;
    for (let [key, product] of basketProductMap) {
      total += Number(product?.item_rate_zoho) * product?.qty;
    }
    if (discountValue > 0) {
      let discountAmount = (discountValue / 100) * total;

      return total - discountAmount;
    } else {
      return total;
    }
  }

  const proceedToCashOut = () => {
    const grandTotalPrice = grandTotal();
    if (grandTotalPrice < 15000) {
      return showPriceAlert(true);
    }
    if (authService.isLogin()) {
      localStorage.setItem("isFrom", "foodBasket");
      dispatch(setCustomBasketRemark(remark));
      navigate("/checkout"); //go to basket checkout
    } else {
      logicContext.setPreviousUrl(location.pathname);
      setOpen(true);
    }
  };

  const continueToLogin = () => {
    navigate("/login");
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {/*  Alert */}
      {/* <LogIntoYourAccount /> */}

      <div>
        <Dialog
          className="h-full pb-16"
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className="h-hug w-full rounded-md border-gray-300 bg-gray-100 shadow shadow-gray-400">
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div className="flex items-center justify-end">
                  <button
                    onClick={handleClose}
                    className="rounded-full p-2 active:bg-gray-200"
                  >
                    <CgClose className="h-5 w-5 text-gravel-500" />
                  </button>
                </div>
                <div className="mt-2 flex justify-start text-sm">
                  <img src={AccountImage} className="h-40 w-full" alt="" />
                </div>
                <div className="cursor mt-4 flex justify-center text-base font-semibold xsm:text-lg ">
                  <div className=" font-bold text-gray-800">
                    Log into your account{" "}
                  </div>
                </div>
                <div className="mt-2 text-center text-xs">
                  <div className="text-gray-500">
                    You are currently not logged into your Grocedy account.
                    Please login or create a new account to proceed to check
                    out.
                  </div>
                </div>
                <div className="mt-5 pb-4 text-center tracking-wider xsm:px-6 sm:px-16">
                  <div
                    onClick={continueToLogin}
                    className="!cursor-pointer rounded-md border-[1px] border-olivine-500 py-2 text-sm font-semibold text-olivine-500 transition duration-300 hover:ring-1 hover:ring-olivine-500"
                  >
                    Log into Account
                  </div>
                  <div className="mt-4">
                    <div
                      onClick={() => navigate("/register")}
                      className="!cursor-pointer py-1 text-sm font-semibold text-olivine-500 opacity-100 hover:underline hover:underline-offset-4 hover:opacity-80"
                    >
                      Create new Account
                    </div>
                  </div>
                </div>
              </DialogContentText>
            </DialogContent>
          </div>
        </Dialog>
      </div>
      {/* End  Alert */}

      <div className=" px-3 pt-8 xsm:px-4 sm:px-8 md:px-10 lg:px-16">
        <div className='relative h-40 w-full bg-[#558223] rounded-xl overflow-hidden'>
          <div className='absolute right-20 top-10 md:right-28 md:top-12'><img src={WrapFive} alt='' className='h-10 w-auto' /></div>
          <div className='absolute -top-4 -right-12 md:-top-6 md:-right-11'><img src={WrapFour} alt='' className='h-28 md:h-32 w-auto' /></div>
          <div className='absolute top-6 right-1 md:top-5 md:right-4'><img src={WrapFour} alt='' className='h-28 md:h-32 w-auto' /></div>
          <div className='absolute top-16 right-14 md:top-14 md:right-20'><img src={WrapFour} alt='' className='h-28 md:h-32 w-auto' /></div>
          <div className='absolute inset-0'>
            <div className='mx-auto max-w-[1600px] px-3 xsm:px-4 sm:px-8 lg:px-14 flex flex-row items-center justify-between h-full'>
              <div className='w-1/2 md:w-3/4 mr-4'>
                <h1 className='text-[min(3.5vw,25px)] font-semibold text-white leading-5 sm:leading-6 lg:leading-7 max-w-xl'>Want to send food items to multiple recipients?</h1>
                <p className='text-[min(2.2vw,15px)] font-semibold text-white'>You can do that on our mobile app</p>
                <a href="https://download.grocedy.com/u/12811202 " target="_blank" rel="noopener noreferrer">
                  <button className='mt-2 px-2 sm:px-4 py-2 sm:py-2.5 rounded-md bg-white text-xs sm:text-sm font-medium text-[#558223] hover:bg-gray-100'>Download Mobile App</button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-3 flex items-center space-x-3 text-xs font-semibold text-gray-500">
          <div className="flex items-center space-x-1">
            <div>
              <HiHome
                onClick={() => navigate("/")}
                className="cursor h-3.5 w-3.5"
              />
            </div>
            <div>
              <IoIosArrowForward className="h-[11px] w-[11px]" />
            </div>
          </div>

          <div className="cursor flex items-center space-x-1">
            <div onClick={() => navigate("/basket/create-basket")}>
              Select Product(s)
            </div>
            <div>
              <IoIosArrowForward className="cursor h-[11px] w-[11px]" />
            </div>
          </div>
          <div className="cursor  flex items-center space-x-1 text-olivine-500">
            <div>Basket list</div>
            <div>
              <IoIosArrowForward className="h-[11px] w-[11px]" />
            </div>
          </div>
        </div>
        <div>
          <div className="flex cursor-pointer items-center space-x-2 pt-4 text-sm font-semibold text-olivine-500">
            <div>
              <IoIosArrowBack className="h-4 w-4" />
            </div>
            <div
              onClick={() => navigate("/basket/create-basket")}
              className="cursor"
            >
              Continue Shopping
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center">
          <div className="w-full max-w-3xl pb-16">
            <div className="mt-6 text-xl font-semibold text-gray-600">
              My Basket
            </div>
            <div className="mt-4 text-sm">
              <div className="hidden grid-cols-4 font-semibold text-gray-500 sm:grid">
                <div className="col-span-2 grid justify-start">PRODUCT</div>
                <div className="col-span-1 grid justify-center">QUANTITY</div>
                <div className="col-span-1 grid justify-end">TOTAL</div>
              </div>
              <hr className="mt-[2px] h-[2px] bg-gray-400" />

              {displayProduct()}

              <div className="mt-10 max-w-sm">
                <h3 className="ml-1 text-xl font-semibold tracking-wide text-gray-700">Custom Basket Information</h3>
                <div className="mt-1 flex flex-col px-6 pt-8 pb-6 bg-[#FAFAFA] border-[1px] border-gray-200 shadow-sm rounded-lg">
                  <div className="w-full">
                    <label htmlFor="recurrence" className="block text-sm font-medium text-gray-700">
                      Do you want your Gift Custom Basket to recur monthly?
                    </label>
                    <select
                      name="recurrence"
                      onChange={handleMonthlyRecurring}
                      id="recurrence"
                      className="mt-1 block w-full rounded-md border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-olivine-500 focus:ring-olivine-500 sm:text-sm"
                    >
                      <option value="no" selected={selectedOption === "no"} className="bg-white text-gray-900">No</option>
                      <option value="yes" selected={selectedOption === "yes"} className="bg-white text-gray-900">Yes</option>

                    </select>
                  </div>

                  {monthlyRecurring === "yes" ? (
                    <div className="flex flex-col">
                      <div className="mt-3 flex items-center gap-3">
                        <input
                          id="recurrence"
                          type="checkbox"
                          checked={isRecurring}
                          onChange={handleChange}
                          className="h-5 w-5 rounded border-[1px] border-gray-300 text-olivine-600 focus:ring-olivine-500 cursor-pointer ring-0 focus:ring-0 checked:ring-0"
                        />
                        <label
                          htmlFor="recurrence"
                          className="text-sm font-semibold text-gray-700"
                        >
                          Recur every month until I cancel
                        </label>
                      </div>

                      {!isRecurring ? (
                        <div className="mt-5">
                          <label>Number of months</label>
                          <div className='mt-1 w-fit px-2 py-1.5 bg-white rounded-md flex flex-row items-center space-x-5 ring-1 ring-gray-300'>
                            <button onClick={() => setRecurrMonths(prev => Math.max(0, prev - 1))} className='h-5 w-5 rounded-full flex items-center justify-center active:bg-gray-200'>
                              <FaMinus className='h-3 w-3 text-gray-600' />
                            </button>
                            <div className='text-gray-600 font-semibold text-sm'>{recurrMonths}</div>
                            <button onClick={() => setRecurrMonths(recurrMonths + 1)} className='h-5 w-5 rounded-full flex items-center justify-center active:bg-gray-200'>
                              <FaPlus className='h-3 w-3 text-gray-600' />
                            </button>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ) : null}

                </div>
              </div>

              <div className="mt-8">
                <div className="text-sm font-bold tracking-wider text-gray-600">
                  Grocedy Savings <span>🎉</span>
                </div>
                <div className="mt-[2px] text-xs font-semibold tracking-wider text-gray-600">
                  You have saved
                  <CurrencyFormat
                    className={"m-2  font-bold text-red-500 "}
                    value={Number.parseFloat(
                      Number.parseFloat(calculateSaving(basketProductMap))
                    )?.toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"₦"}
                  />
                  shopping with us.
                </div>
              </div>
              <div className="mt-8">
                <label className="pl-3 text-xs font-semibold text-gray-600">
                  Additional Comments
                </label>
                <textarea
                  placeholder="Write your message..."
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  rows="4"
                  className="w-full rounded-md border-[0.5px] border-gray-400 bg-[#F0F2E8] text-sm font-semibold text-gray-500 placeholder:text-sm placeholder:text-gray-400 focus:border-olivine-500 focus:ring-olivine-500"
                ></textarea>
              </div>
              <div>
                <div className="mt-4 grid justify-end">
                  <div className="flex flex-col text-right">
                    <div className="mt-4 pr-3 text-sm font-bold tracking-wider text-gray-600">
                      TOTAL:
                      <CurrencyFormat
                        className={"font-bold "}
                        value={Number.parseFloat(grandTotal())?.toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      />
                    </div>
                    <div className="mt-1 pr-3 text-[9px] font-semibold tracking-wider text-gray-500">
                      *Shipping and to be calculated at checkout
                    </div>
                    <div className="">
                      <Popover className="relative">
                        <>
                          <Popover.Button
                            onClick={() => proceedToCashOut()}
                            className={` w-full focus:text-olivine-700 focus:outline-none lg:w-auto`}
                          >
                            <div className="mt-[1px] rounded-md bg-olivine-500 px-10 py-3 text-sm font-semibold tracking-wider text-white transition duration-300 hover:bg-olivine-600">
                              <div>PROCEED TO CHECKOUT</div>
                            </div>
                          </Popover.Button>
                        </>
                      </Popover>
                    </div>
                  </div>
                </div>
                {/* end alert */}

                {/*  Price Alert */}
                {priceAlert && (
                  <div>
                    <Dialog
                      className="h-full"
                      open={true}
                      onClose={() => showPriceAlert(false)}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <div className="h-hug w-full rounded-md border-gray-300 bg-gray-100 shadow shadow-gray-400">
                        <DialogContent>
                          <DialogContentText id="alert-dialog-description">
                            <div className="flex items-center justify-end">
                              <button
                                onClick={() => showPriceAlert(false)}
                                className="rounded-full p-2 active:bg-gray-200"
                              >
                                <CgClose className="h-5 w-5 text-gravel-500" />
                              </button>
                            </div>
                            <div className="mt-2 flex justify-start text-sm">
                              <img
                                src={MinimumBasketImage}
                                className="h-32 w-full"
                                alt=""
                              />
                            </div>
                            <div className="cursor mt-4 flex justify-center text-base font-semibold xsm:text-lg ">
                              <div className=" font-bold text-gray-800">
                                Note
                              </div>
                            </div>
                            <div className="mt-2 max-w-md text-center text-xs">
                              <div className="text-gray-500">
                                "Please note that our minimum purchase amount is
                                N15,000. Unfortunately, your current basket
                                value does not meet this requirement. To proceed
                                with your purchase, kindly add more items to
                                your basket."
                              </div>
                            </div>
                            <div className="mt-5 pb-4 text-center tracking-wider xsm:px-6 sm:px-16">
                              <div
                                onClick={() => showPriceAlert(false)}
                                className="!cursor-pointer rounded-md border-[1px] border-olivine-500 px-6 py-2 text-sm font-semibold text-olivine-500 transition-all duration-200 focus:outline-none focus:ring-[2px] focus:ring-olivine-500 focus:ring-opacity-60 focus:ring-offset-1 active:bg-olivine-100 active:ring-1 active:ring-olivine-500"
                              >
                                Continue shopping
                              </div>
                            </div>
                          </DialogContentText>
                        </DialogContent>
                      </div>
                    </Dialog>
                  </div>
                )}

                {/* end Price alert */}
                <div></div>
                <div></div>
              </div>
              <div></div>
            </div>
          </div>

          {/* show Shop from our Grochills section modal */}
          <Transition appear show={grochilsSectionModal} as={Fragment}>
            <DailogUi
              as="div"
              className="relative z-50"
              onClose={() => setGrochilsSectionModal(false)}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black/25" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 text-center">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <DailogUi.Panel className="w-full max-w-xl transform overflow-hidden rounded-xl bg-[#F0F0F0] text-left align-middle shadow-xl transition-all">
                      <div className="scrollbar-thumb-[#1a3517] scrollbar-track-[#265426] h-fit max-h-[95vh] overflow-y-scroll p-2 scrollbar-thin">
                        <div
                          onClick={() =>
                            setGrochilsSectionModal(
                              !grochilsSectionModal
                            )
                          }
                          className="fixed right-3 top-2.5 z-40 w-fit cursor-pointer rounded-full bg-gray-800 p-1.5 text-white hover:bg-gray-600 active:bg-gray-700 transition-all duration-200"
                        >
                          <IoClose className="h-5 w-5" />
                        </div>
                        <div className="px-3 w-full max-w-lg mx-auto mb-6">
                          <h2 className="mt-10 text-[min(5vw,28px)] font-bold text-center text-gray-700 leading-tight">{`${isMissingProd === "isBasket" ? "You haven't shopped from Pick Your Basket yet." : "Your Basket's Almost There"}`}</h2>
                          <p className="mt-1 text-center text-[min(4vw,15px)] font-medium text-gray-500 leading-tight">
                            {`${isMissingProd === "isBasket" ? "Select items and add them to your cart." : "Shop your frozen essentials such as beef, chicken, etc."}`}
                          </p>
                          <div className="mt-6 w-full max-w-lg mx-auto grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {isMissingProd === "isBasket" && (
                              allPickProductList && allPickProductList?.length ?
                                allPickProductList?.slice(0, 4).map((prod) => (
                                  <div className="flex flex-row items-center space-x-2 bg-white p-3 rounded-md shadow-sm">
                                    <img src={CherriesImage} alt="img" className="size-20 aspect-auto object-cover" />
                                    <div>
                                      <h3 className="text-xs font-medium text-gray-700">{prod?.name}</h3>
                                      <p className="text-sm font-bold text-gray-700">
                                        {`₦ ${Number.parseFloat(prod?.item_rate_zoho)?.toFixed(2)}`}
                                      </p>
                                    </div>
                                  </div>
                                )) : null
                            )}

                            {isMissingProd === "isButcher" && (
                              allGrochillProductList && allGrochillProductList?.length ?
                                allGrochillProductList?.slice(0, 4).map((prod) => (
                                  <div className="flex flex-row items-center space-x-2 bg-white p-3 rounded-md shadow-sm">
                                    <img src={CherriesImage} alt="img" className="size-20 aspect-auto object-cover" />
                                    <div>
                                      <h3 className="text-xs font-medium text-gray-700">{prod?.name}</h3>
                                      <p className="text-sm font-bold text-gray-700">
                                        {`₦ ${Number.parseFloat(prod?.item_rate_zoho)?.toFixed(2)}`}
                                      </p>
                                    </div>
                                  </div>
                                )) : null
                            )}
                          </div>
                          <button onClick={() => navigate(isMissingProd === "isBasket" ? "/basket/create-basket" : "/grochill/create-basket")} className="mt-8 w-full transform cursor-pointer rounded-md bg-[#558223] px-6 py-3 text-sm font-semibold text-white transition-all duration-200 hover:bg-olivine-500/80 focus:outline-none active:bg-olivine-600 @sm:mt-0 @sm:max-w-[200px]">
                            {`Go to ${isMissingProd === "isBasket" ? "Pick your Basket" : "Grochills"}`}
                          </button>
                        </div>
                      </div>
                    </DailogUi.Panel>
                  </Transition.Child>
                </div>
              </div>
            </DailogUi>
          </Transition>
        </div>
        <Modal
          visible={showModal}
          onClose={handleOnClose}
          selected={selectedModal}
          switcher={switchToMonthly}
        />
      </div>
    </>
  );
}

export default MyBasketList;
